import * as React from "react";
import MobileInstructions from "./components/mobile-instructions";
import WebInstructions from "./components/web-instructions";
import { useOutletContext } from "react-router-dom";

export default function Declaration() {
	const [handleChangeWebStyleLayout, layout] = useOutletContext();

	return (
		<React.Fragment>
			{layout === "mobile" 
				? <MobileInstructions />
				: <WebInstructions onChangeWebStyleLayout={handleChangeWebStyleLayout}/>
			}
		</React.Fragment>
	);
}
